import HelpPane from 'components/Common/HelpPane'
import List from 'components/Common/List'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import Divider from 'LuxKit/Divider'
import Group from 'components/utils/Group'
import BodyText from 'LuxKit/Typography/BodyText'
import Heading from 'LuxKit/Typography/Heading'
import { fillArray } from 'lib/array/arrayUtils'
import { rem } from 'polished'
import React from 'react'
import styled from 'styled-components'
import CarHireImportantInformationSkeleton from './CarHireImportantInformationSkeleton'
import { TabOptions } from './CarHireInclusionsAndDetailsModal'

const ImportantInfoSection = styled(Group)<{ gap: number }>`
  padding: ${({ gap = 0 }) => rem(gap)} 0;
`

// If this is an 'odd' child, it's not actually inbetween anything, don't show it
const DetailsDivider = styled(Divider)`
  &:last-child {
    display: none;
  }
`

interface Props {
  offerImportantInformation?: Array<App.CarHireImportantInformation>
  displayCategory: string
  hasError: boolean
  showTitle?: boolean
}
function CarHireImportantInformationList(props: Props) {
  const { offerImportantInformation, displayCategory, hasError, showTitle = true } = props

  const isParagraphAllowed = (paragraph: string): boolean => {
    const allowedStarts = [
      'Theft waiver',
      'Collision damage',
      'Personal accident',
    ]
    return allowedStarts.some(item => paragraph.startsWith(item))
  }

  return (
    <>

      {hasError && (
        <div>
          <VerticalSpacer gap={16}>
            <Heading variant="heading5">Oh no, something went wrong</Heading>
            <BodyText variant="medium">We ran into a problem when trying to load the information. Please go back and try again or call our support team on the number below.</BodyText>
          </VerticalSpacer>
          <HelpPane />
        </div>
      )}

      {!hasError && offerImportantInformation?.length === 0 && (
        <>
          {fillArray(1).map((_, index) => (
            <CarHireImportantInformationSkeleton key={index} />
          ))}
        </>
      )}

      {offerImportantInformation && offerImportantInformation?.length > 0 && (
        <ImportantInfoSection direction="vertical" gap={showTitle ? 16 : 0}>
          {offerImportantInformation.filter((info) => info.category === displayCategory).map(info =>
            <>
              {showTitle && <BodyText key={info.title} weight="bold" variant="medium">{info.title}</BodyText>}
              <List type="ul">
                {info.paragraphs.map((paragraph) => {
                  const containsBulletPoint = paragraph.includes('\u2022')
                  if (displayCategory === TabOptions.COVERAGE && !isParagraphAllowed(paragraph)) return
                  return (
                    <BodyText variant="medium" as={containsBulletPoint ? 'div' : 'li'} key={paragraph}>
                      {paragraph.replace('\u2022', '\u2043')}
                    </BodyText>
                  )
                })}
              </List>
              <DetailsDivider key={info.title} kind="primary" />
            </>,
          )}
        </ImportantInfoSection>
      )}
    </>
  )
}

export default CarHireImportantInformationList
